<template>
	<div
		class="tw-flex tw-justify-between tw-items-center p-dialog-header tw-py-4 tw-px-6"
		:style="{ margin: negativeMargin ? '-20px -20px 0' : 'auto' }"
	>
		<h3 class="tw-text-app-color-font"><slot></slot></h3>
		<close-icon v-if="!noIcon" class="cursor-pointer" @click="$emit('closeClicked')"></close-icon>
	</div>
</template>
<script>
import CloseIcon from '../../icons/close-icon';

export default {
	components: { CloseIcon },
	name: 'p-header-dialog',
	props: {
		negativeMargin: {
			default: true,
		},
		noIcon: {
			default: false,
		},
	},
};
</script>

<style scoped lang="scss">
.p-dialog-header {
	background-color: var(--app-color-gray-white);
	border-bottom: 1px solid var(--app-color-gray);
	border-top: 1px solid var(--app-color-gray);
}
</style>



// WEBPACK FOOTER //
// src/modules/shared/components/ui/dialog/p-header-dialog.vue